export function cameFromElal() {
    try {
        const { hostname } = new URL(document.referrer);
        return hostname === 'elal.com' || hostname === 'www.elal.com';
    } catch {
        return false;
    }
}
